import { STATUTE_SEARCH_ENDPOINTS } from "../services/apiEndpoints";
import { deductCredits } from "../utils/HelperFunction/deductCredits";
import { showInsufficientCreditsModal } from "./creditActions";
import { searchStatutesApi } from "../services/api/statuteSearchApi";
export const STATUTE_SEARCH_REQUEST = "STATUTE_SEARCH_REQUEST";
export const STATUTE_SEARCH_SUCCESS = "STATUTE_SEARCH_SUCCESS";
export const STATUTE_SEARCH_FAILURE = "STATUTE_SEARCH_FAILURE";
export const STATUTE_SECTIONS_REQUEST = "STATUTE_SECTIONS_REQUEST";
export const STATUTE_SECTIONS_SUCCESS = "STATUTE_SECTIONS_SUCCESS";
export const STATUTE_SECTIONS_FAILURE = "STATUTE_SECTIONS_FAILURE";
let currentAbortController = null; // Maintain a single abort controller

export const statuteSearchResults =
  (userQuery, searchMode, top, skip, filters) => async (dispatch, getState) => {
    try {
      // Abort any ongoing request
      if (currentAbortController) {
        currentAbortController.abort();
      }

      // Create a new AbortController instance
      currentAbortController = new AbortController();
      const { signal } = currentAbortController;

      const state = getState();
      const { credits, userId } = state.credit;
      let creditsToDeduct = 1;
      if (credits <= 0 || credits <= creditsToDeduct) {
        dispatch(showInsufficientCreditsModal());
        return;
      }

      dispatch({
        type: STATUTE_SEARCH_REQUEST,
      });

      const { year, letter, province, type } = filters;

      let filterString = "";

      if (year) {
        filterString += `Year eq '${year}'`;
      }

      if (letter) {
        const nextLetter = String.fromCharCode(letter.charCodeAt(0) + 1);
        if (filterString) {
          filterString += ` and (Statute_Name ge '${letter}' and Statute_Name lt '${nextLetter}')`;
        } else {
          filterString = `(Statute_Name ge '${letter}' and Statute_Name lt '${nextLetter}')`;
        }
      }

      if (province) {
        filterString += filterString ? " and " : "";
        filterString += `Province eq '${province}'`;
      }

      if (type) {
        filterString += filterString ? " and " : "";
        filterString += `Statute_Type eq '${type}'`;
      }

      const requestBody = {
        query: userQuery,
        sort_by: "",
        filter: filterString || "",
        search_field_mode: searchMode,
        top: top,
        skip: skip,
        count: true,
      };

      const response = await searchStatutesApi(requestBody, signal);

      if (response.status === 200) {
        const responseData = response.data;

        dispatch({
          type: STATUTE_SEARCH_SUCCESS,
          payload: responseData,
        });

        const success = deductCredits(
          { userId, creditsToDeduct, event: "Search by keywords of Statute" },
          dispatch
        );
        if (!success) {
          console.error("Failed to deduct credits after successful API call.");
        }
      } else {
        throw new Error("Failed to fetch statute search results");
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Request aborted");
      } else {
        dispatch({
          type: STATUTE_SEARCH_FAILURE,
          payload: error.message,
        });
      }
    }
  };

export const searchStatutesByYear = (userQuery, year) => async (dispatch) => {
  try {
    const requestBody = {
      query: userQuery,
      filter: `Year eq '${year}'`,
      mode: "Title",
      sort_by: "",
      top: 10,
      skip: 0,
      count: true,
    };
    const response = await searchStatutesApi(requestBody);

    if (response.status === 200) {
      const responseData = response.data;

      // Filter out results with the specific text
      // const filteredResults = responseData.value.filter(
      //   (item) => item.Statute !== 'Error Code:700 Sorry Something went wrong'
      // );
      dispatch({
        type: STATUTE_SEARCH_SUCCESS,
        payload: responseData,
      });
    } else {
      throw new Error("Failed to fetch statute search results");
    }
  } catch (error) {
    dispatch({
      type: STATUTE_SEARCH_FAILURE,
      payload: error.message,
    });
  }
};

export const searchStatutesByLetter = (letter) => async (dispatch) => {
  try {
    const nextLetter = String.fromCharCode(letter.charCodeAt(0) + 1);
    const requestBody = {
      query: "",
      filter: `Statute_Name ge '${letter}' and Statute_Name lt '${nextLetter}'`,
      search_field_mode: "Title",
      sort_by: "",
      top: 10,
      skip: 0,
      count: true,
    };
    const response = await searchStatutesApi(requestBody);

    if (response.status === 200) {
      const responseData = response.data;

      // Filter out results with the specific text
      // const filteredResults = responseData.value.filter(
      //   (item) => item.Statute !== 'Error Code:700 Sorry Something went wrong'
      // );
      dispatch({
        type: STATUTE_SEARCH_SUCCESS,
        payload: responseData,
      });
    } else {
      throw new Error("Failed to fetch statute search results");
    }
  } catch (error) {
    dispatch({
      type: STATUTE_SEARCH_FAILURE,
      payload: error.message,
    });
  }
};

export const applyStatuteFilters =
  (userQuery, filters, searchMode, top = 10, skip = 0) =>
  async (dispatch, getState) => {
    try {
      // Abort any ongoing request
      if (currentAbortController) {
        currentAbortController.abort();
      }

      // Create a new AbortController instance
      currentAbortController = new AbortController();
      const { signal } = currentAbortController;

      const state = getState();
      const { credits, userId } = state.credit;
      let creditsToDeduct = 1;
      if (credits <= 0 || credits <= creditsToDeduct) {
        dispatch(showInsufficientCreditsModal()); // Trigger modal if credits are insufficient
        return;
      }

      dispatch({
        type: STATUTE_SEARCH_REQUEST,
      });

      const { year, letter, province, type } = filters;

      let filterString = "";

      if (year) {
        filterString += `Year eq '${year}'`;
      }

      if (letter) {
        const nextLetter = String.fromCharCode(letter.charCodeAt(0) + 1);
        if (filterString) {
          filterString += ` and (Statute_Name ge '${letter}' and Statute_Name lt '${nextLetter}')`;
        } else {
          filterString = `(Statute_Name ge '${letter}' and Statute_Name lt '${nextLetter}')`;
        }
      }

      if (province) {
        filterString += filterString ? " and " : "";
        filterString += `Province eq '${province}'`;
      }

      if (type) {
        filterString += filterString ? " and " : "";
        filterString += `Statute_Type eq '${type}'`;
      }

      const requestBody = {
        query: userQuery || "",
        filter: filterString || "",
        search_field_mode: searchMode,
        sort_by: "",
        top: top,
        skip: skip || 0,
        count: true,
      };

      const response = await searchStatutesApi(requestBody, signal);

      if (response.status === 200) {
        const responseData = response.data;

        // Dispatch the success action with the data
        dispatch({
          type: STATUTE_SEARCH_SUCCESS,
          payload: responseData,
        });

        // Deduct credits after successful API call
        const success = deductCredits(
          { userId, creditsToDeduct, event: "Filters of Statute Search" },
          dispatch
        );
        if (!success) {
          console.error("Failed to deduct credits after successful API call.");
        }
      } else {
        throw new Error("Failed to fetch statute search results");
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Request aborted");
      } else {
        dispatch({
          type: STATUTE_SEARCH_FAILURE,
          payload: error.message,
        });
      }
    }
  };

export const searchSections =
  (userQuery, statuteName, searchMode) => async (dispatch) => {
    try {
      dispatch({
        type: STATUTE_SECTIONS_REQUEST,
      });

      const requestBody = {
        query: userQuery,
        sort_by: "",
        filter: `(Statute_Name eq '${statuteName}')`,
        search_field_mode: searchMode,
        top: 50,
        skip: 0,
        count: true,
      };
      const response = await searchStatutesApi(requestBody);

      if (response.status === 200) {
        const responseData = response.data;

        // Filter out results with the specific text
        const filteredResults = responseData["search_results"].filter(
          (item) => item.Statute !== "Error Code:700 Sorry Something went wrong"
        );
        dispatch({
          type: STATUTE_SECTIONS_SUCCESS,
          payload: filteredResults,
        });
      } else {
        throw new Error("Failed to fetch statute search results");
      }
    } catch (error) {
      dispatch({
        type: STATUTE_SECTIONS_FAILURE,
        payload: error.message,
      });
    }
  };
